



























































































































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Ref} from "vue-property-decorator";
import type {IdTag} from "@/api/models/products/IdTag";
import SmbTextInput from "@/components/ui/SmbTextInput/SmbTextInput.vue";
import IdTagSticker from "@/components/helper/IdTagSticker.vue";
import DocumentUpload from "@/components/helper/DocumentUpload.vue";
import DocumentList from "@/components/helper/DocumentList.vue";

@Component({
  components: {
    IdTagSticker,
    SmbTextInput,
    DocumentUpload,
    DocumentList
  },
  metaInfo(this: ViewIdTag) {
    const idTag = this.tag;

    return {
      title: idTag?.description ?? "ID-TAG",
    };
  },
})
export default class ViewIdTag extends Vue {
  @Prop({
    type: Object,
    default: null
  })
  public readonly tag!: IdTag | null;

  @Ref("documentList")
  public readonly documentList!: DocumentList;

  public onDocumentUploaded(): void {
    if (this.documentList) {
      this.documentList.loadDocuments();
    }
  }
}
